import Logo from 'assets/images/edduz-gray-logo.svg';
import PrintContext from 'components/Pages/Public/Participant/Content/Ticket/context';
import React, { useContext } from 'react';
import styles from './styles.module.css';

const Footer = () => {
  const { isPrinting } = useContext(PrintContext);

  return (
    <div className={isPrinting ? 'noprint2' : `${styles.footer}`}>
      <p style={{ fontSize: '16px' }}>
        Se sua dúvida é sobre compras na Blinket, é só acessar nossa{' '}
        <a href='https://ajuda.eduzz.com/hc/pt-br' rel='noopener' target='_blank' style={{ textDecoration: 'none' }}>
          Central de Ajuda
        </a>{' '}
        ou enviar um e-mail para suporte@eduzz.com.
      </p>

      <div style={{ padding: '25px' }}>
        <img src={Logo} alt='Logo eduzz' />
      </div>

      <p style={{ fontSize: '16px' }}>
        A Blinket é a ferramenta de eventos da Eduzz, onde qualquer pessoa pode promover eventos e tranformar vidas por
        meio do conhecimento.
      </p>
      <a href='https://www.eduzz.com/' rel='noopener' target='_blank' style={{ textDecoration: 'none' }}>
        Conheça nossas soluções.
      </a>
    </div>
  );
};

export default Footer;
